import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ServiceManagment {
  apiBaseUrl = environment.apiBaseUrl;
  constructor(private _httpClient: HttpClient) { }

  getAllCategories(id:any) {
    return this._httpClient.get(`${this.apiBaseUrl}/subCategories/parent/${id}`,);
  }

  get(params: { 'page[number]': number, 'page[size]': number, 'orderBy[modifiedOn]': string, 'searchFilter[name]'?: string, 'filter[status]': string, }) {
    return this._httpClient.get(`${this.apiBaseUrl}/services`, { params });
  }

  updateFee(data: any) {
    return this._httpClient.patch(`${this.apiBaseUrl}/configs/adminFees`, data);
  }

  getFee() {
    return this._httpClient.get(`${this.apiBaseUrl}/configs/adminFees`);
  }

  getConfig() {
    return this._httpClient.get(`${this.apiBaseUrl}/configs`);
  }

  getCategories() {
    return this._httpClient.get(`${this.apiBaseUrl}/categories`);
  }

  getInterests() {
    return this._httpClient.get(`${this.apiBaseUrl}/interests`);
  }

  getLocations(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/locations${query}`);
  }

  AddService(data: any) {
    return this._httpClient.post(`${this.apiBaseUrl}/services`, data);
  }

  getService(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/services${query}`);
  }

  deleteService(id: string) {
    return this._httpClient.delete(`${this.apiBaseUrl}/services/${id}`);
  }

  getServiceById(id: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/services/${id}`);
  }

  updateService(id: string, data: any) {
    return this._httpClient.put(`${this.apiBaseUrl}/services/${id}`, data);
  }

  updateLocation(id: string, data: any) {
    return this._httpClient.put(`${this.apiBaseUrl}/locations/${id}`, data);
  }

  getBooking(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/bookings${query}`);
  }

  updateBooking(id: string, data: any) {
    return this._httpClient.put(`${this.apiBaseUrl}/bookings/${id}`, data);
  }


  getStatisticsByServiceId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/statistics/${query}`);
  }

  getLocationById(id: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/locations/${id}`);
  }

  getStatisticsByLocationId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/statistics/${query}`);
  }

  getstatisticsDetailByCustomerId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/statistics/${query}`);
  }

  getRatingByServiceId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/reviews-and-ratings/${query}`);
  }

  getRatingBylocationId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/reviews-and-ratings/${query}`);
  }

  getRatingByComboPackageId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/reviews-and-ratings/${query}`);
  }

  getRatingByVendorId(query: string) {
    return this._httpClient.get(`${this.apiBaseUrl}/reviews-and-ratings/${query}`);
  }

  getFeaturedCheck() {
    return this._httpClient.get(`${this.apiBaseUrl}/services/featured/check`);
  }

  getPermission() {
    return this._httpClient.get(`${this.apiBaseUrl}/permissions/canNotifyCustomers`);
  }

  getServiceOnlineDays(id: any){
    return this._httpClient.get(`${this.apiBaseUrl}/services/get-service-online-days/${id}`);
  }

}
